import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';
import { FnGridLookupService } from '../../services/fn-grid-lookup.service';

@Component({
    selector: 'fn-grid-lookup',
    templateUrl: 'fn-grid-lookup.component.html',
    styleUrls: ['fn-grid-lookup.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FnGridLookupComponent
    extends FnGridAbstractCell
    implements OnInit {
    lookupArray: Array<any> = [];
    lookupKeyVal: any;
    constructor(private lookupService: FnGridLookupService) {
        super();
    }

    // Init
    override ngOnInit() {
        super.ngOnInit();
        this.lookupArray = this.lookupService.getLookArrayForKey(
            this.column.lookupArrayKey
        );

        this.lookupKeyVal = this.row.data[this.column.lookupIdKeyInRow];
    }

    override changeAction($event: any) {
        if (this.lookupKeyVal + ''.length == 0) {
            // TODO in case of
            this.cellValue = '';
        } else {
            for (let i = 0; i < this.lookupArray.length; i++) {
                if (this.lookupArray[i].primaryKey == this.lookupKeyVal) {
                    this.cellValue = this.lookupArray[i][this.column.lookupDescKey];
                    this.row.data[this.column.lookupIdKeyInRow] = this.lookupKeyVal;
                    this.selectionChange.emit({
                        cellValue: this.cellValue,
                        lookupKeyVal: this.lookupKeyVal,
                    });
                    this.editToggle();
                    break;
                }
            }
        }
    }
}
